class CausesManagement {
  constructor() {
    if (document.querySelector(".causes-mobile-button")) {
      this.causesMobileButton = document.querySelector(".causes-mobile-button")
      this.closeCausesListButton = document.querySelector(
        ".close-mobile-causes-box"
      );
    }

    // If on front page reset cookie causes
    if (document.querySelector(".causesBox")) {
      document.cookie =
        "causes=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
    }

    this.causesCheckbox = document.querySelectorAll(".causes-checkbox")

    this.events()
  }

  events() {
    if (document.querySelector(".causes-mobile-button")) {
      this.causesMobileButton.addEventListener("click", () =>
        this.displayCausesMobile()
      );
      this.closeCausesListButton.addEventListener("click", () =>
        this.displayCausesMobile()
      );
    }

    if (this.causesCheckbox) {
      this.causesCheckbox.forEach((el) => {
        el.addEventListener("click", (e) => {
          this.manageCausesInCookies(e)
          console.log(el)
        });
      });
    }
  }

  displayCausesMobile() {
    let causesList = document.querySelector(".causes-list")
    if (!causesList.classList.contains("show-mobile-causes-list")) {
      causesList.classList.add("show-mobile-causes-list")
    } else {
      causesList.classList.remove("show-mobile-causes-list")
    }
  }

  manageCausesInCookies(e) {
    //First need to get the actual list of causes in cookies
    //replace string by array
    //keep el of array if start by causes (indexOf(name))

    const cookiesDecoded = decodeURIComponent(document.cookie)
    const cookiesArr = cookiesDecoded.split("; ")
    const cookieName = "causes="
    let cookieCauses
    cookiesArr.forEach((val) => {
      if (val.indexOf(cookieName) === 0)
        cookieCauses = val.substring(cookieName.length)
    })
    let causes = e.target;
    let causesList;

    //If causes is checked & if already cookie cause add coma and new cause
    // else just create new cookie cause
    //If unchecked, get the cause id to remove
    // split string of causes in cookies and filter it to remove cause id
    // set new cookies
    if (causes.checked) {
      if (cookieCauses) {
        causesList = cookieCauses + "," + causes.getAttribute("data-id")
      } else {
        causesList = causes.getAttribute("data-id")
      }
      document.cookie = "causes=" + causesList;
    } else {
      let causesToRemove = causes.getAttribute("data-id")
      let actualCausesArray = cookieCauses.split(",")
      causesList = actualCausesArray.filter(
        (causes) => causes !== causesToRemove
      );
      document.cookie = "causes=" + causesList
    }
    console.log(causesList)
  }
}

export default CausesManagement
